module.exports = "\n<!-- <appHeader></appHeader-->\n<main id=\"symptom-checker\">\n    <div class=\"container-fluid bodyRow checkerRow symptom-checker-container\" [ngStyle]=\"{'max-width': checkWidth + 'px'}\">\n        <router-outlet></router-outlet>\n    </div>\n</main>\n<!-- <appFooter></appFooter> -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main